import React from 'react'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules"; // ✅ Removed Navigation
import "swiper/css";
import "swiper/css/pagination";

function Daissy() {
   
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/semiverticals" className="block py-1 pl-4 hover:underline mt-6">Semi Verticals -</Link>
           <span className="block py-1 pl-4 mt-6">Daisy</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/daisy22.jpg" alt="Daisy" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">Daisy</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Versatile and functional display units with all the options for food retail and food service.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">DAISY is a very complete and flexible solution to equip small and medium-sized stores. Chilled, heated and dry ambient display cases and semi-verticals are available in two widths, 100/91 cm, and two heights, 120/135 cm, in a wide array of sizes and options so that nothing remains unsold!.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <p className="text-xl lg:text-2xl opacity-90">Packaged Meat and Sushi <span className=' text-blue-400'>-1… +5 °C</span> (3M1)</p>

         <p className="text-xl lg:text-2xl opacity-90">Beverages, Packaged Charcuterie and Pastry<span className=' text-blue-400'>-1… +7 °C</span> (3M2)</p>
       <p className="text-xl lg:text-2xl opacity-90">Packaged Hot Food<span className='text-red-600'> +65 °C</span> </p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3">CO2 | Glycol |  R290</p>
         </div>

         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/daisy21.jpg" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Grab and Go so easy, always at hand!</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Whether it's beverages, sandwiches, cakes, sushi, desserts, salads... or roasted chicken, pasta, noodles, soups... the DAISY refrigerated and heated semi-verticals solution is the answer to displaying your packaged goods simply and efficiently.</div>
</div>

                
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Less investment, faster installation</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>New DAISY TWIN refrigerated semi-vertical. The benefits of the gondola layout adding up to greater energy savings, easier installation and maintenance, lower investment, faster return. Among other things, thanks to the single-channel refrigeration system and shared evaporator.</div>
</div>
 {/* ✅ Image Wrapper */}
 <div className="w-full md:w-1/2">
                 <img src="/images/daisy23.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
    {/* case 3 */}
    <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/daisy24.jpg" className="max-w-full h-auto object-contain" />
               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl lg:text-4xl">The perfect partner for selling hot food on-the-go</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>With an innovative ventilated heating system, DAISY heated semi-verticals are 20% more efficient than the conventional hot plate and heating lamps.

Available with sliding or pivoting service doors for quick product replenishment and front doors option for greater energy savings.</div>
</div>
                
             </div>
         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center">
  {[
    {
      img: "images/daisycard21.jpg",
      text: "Refrigerated models with night curtain.",
    },
    {
      img: "images/daisycard22.jpg",
      text: "Front door option for greater energy savings.",
    },
    {
      img: "images/daisycard23.gif",
      text: "Models with steel back or with rear service doors for quick product replenishment.",
    },
    {
      img: "images/daisycard24.jpg",
      text: "Internal components easy to remove and clean.",
    },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6 md:mt-20">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>


     </div>
    
  
        </div>
      )
    }

export default Daissy